import { isAxiosError } from 'axios';

import { apiClient } from '@/services/api';
import { NHDFindings } from '@/types/NHD';
import { logger } from '@/utils/logger/loggerInstance';

export const fetchNHDFindings = async (propertyId: string): Promise<NHDFindings | null> => {
  const url = `/properties/${propertyId}/nhd`;
  logger.debug(`GET ${url}`);
  try {
    const response = await apiClient.get<NHDFindings>(url);
    return response.data;
  } catch (err) {
    // Only return null for the specific "no NHD report on file" 404.
    // A 404 with code item_not_found (property missing) or any other error
    // should surface so the UI can show an appropriate error state.
    if (
      isAxiosError(err) &&
      err.response?.status === 404 &&
      err.response.data?.code === 'no_nhd_report'
    ) {
      return null;
    }
    throw err;
  }
};

export const applyNHDOverride = async (propertyId: string): Promise<void> => {
  const url = `/properties/${propertyId}/nhd/override`;
  logger.debug(`POST ${url}`);
  await apiClient.post(url);
};

export const removeNHDOverride = async (propertyId: string): Promise<void> => {
  const url = `/properties/${propertyId}/nhd/override`;
  logger.debug(`DELETE ${url}`);
  await apiClient.delete(url);
};
